const SIZE_INJECTION_KEY = Symbol("SIZE_INJECTION_KEY"), ORIENTATION_INJECTION_KEY = Symbol("ORIENTATION_INJECTION_KEY"), TYPE_INJECTION_KEY = Symbol("TYPE_INJECTION_KEY");
export {
  ORIENTATION_INJECTION_KEY,
  SIZE_INJECTION_KEY,
  TYPE_INJECTION_KEY
};
//# sourceMappingURL=injectionKeys.js.map
